/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gpName: NonNullable<unknown>, dealName: NonNullable<unknown>, lpName: NonNullable<unknown> }} Coinvestments_Editemail_Defaultsubject3Inputs */

const en_coinvestments_editemail_defaultsubject3 = /** @type {(inputs: Coinvestments_Editemail_Defaultsubject3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gpName} ${i?.dealName} // Co-Investment Invitation - ${i?.lpName}`)
};

/**
* | output |
* | --- |
* | "{gpName} {dealName} // Co-Investment Invitation - {lpName}" |
*
* @param {Coinvestments_Editemail_Defaultsubject3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_defaultsubject3 = /** @type {((inputs: Coinvestments_Editemail_Defaultsubject3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Defaultsubject3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_defaultsubject3(inputs)
});
export { coinvestments_editemail_defaultsubject3 as "coInvestments_editEmail_defaultSubject" }